<template>
  <v-dialog v-model="isOpenDialog" width="1000px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title
          >{{ type === 'sms' ? 'TÌM KIẾM VÀ CHỌN HỌC SINH' : 'THÊM HỌC SINH VÀO NHÓM' }}
        </v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card md="12" outlined class="ma-4 elevation-0">
        <StudentFilterSMS v-if="type === 'sms'" @on-excel-import="onExcelImport" />
        <AddStudentFilter v-else />
      </v-card>
      <v-card md="12" outlined class="mx-4 mb-6 elevation-0">
        <div v-if="type === 'sms'">
          <ListStudentsSMS v-if="!isExcelImport" />
          <ListStudentsIndependent v-else />
        </div>
        <ListStudents v-else ref="clear" />
      </v-card>
      <hr color="#E0E0E0" />
      <v-card-actions>
        <v-btn class="ma-2" outlined light @click="cancel" width="100px">Hủy</v-btn>
        <v-spacer></v-spacer>
        <div class="pr-4 grey--text">Đã chọn {{ (selectedStudent || []).length }} học sinh</div>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="type === 'sms' ? cancel() : save()" width="100px">{{
          type === 'sms' ? 'Chọn' : 'Thêm'
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import AddStudentFilter from '@/modules/tuitionFee/detail-group/dialogAddStudent/StudentFilter'
import StudentFilterSMS from '@/modules/post/selectStudentDialog/StudentFilter.vue'
import ListStudents from '@/modules/tuitionFee/detail-group/dialogAddStudent/ListStudents'
import ListStudentsSMS from '@/modules/post/selectStudentDialog/ListStudentSMS.vue'
import ListStudentsIndependent from '@/modules/post/selectStudentDialog/ListStudentsIndependent.vue'

export default {
  components: {
    AddStudentFilter,
    ListStudents,
    StudentFilterSMS,
    ListStudentsSMS,
    ListStudentsIndependent
  },
  data() {
    return {
      isOpenDialog: false,
      type: '',
      isExcelImport: false
    }
  },
  computed: {
    ...mapState('tuitionFeeGroup', ['group']),
    ...mapState('tuitionFeeGroupStudent', ['selectedStudent'])
  },
  methods: {
    ...mapActions('students', ['requestPageSettings', 'searchStudents']),
    ...mapActions('tuitionFeeGroupStudent', ['addStudent']),
    ...mapMutations('tuitionFeeGroupStudent', ['setSelectedStudent']),

    openDialog(type) {
      this.isOpenDialog = true
      this.type = type
    },
    cancel() {
      this.isOpenDialog = false
      this.isExcelImport = false
    },
    async save() {
      if (this.selectedStudent[0]) {
        try {
          this.$loading.active = true
          let studentExited = await this.addStudent()
          if (studentExited[0]) this.$alert.error({ title: 'Lỗi dữ liệu', description: studentExited.join('<br/>') })
          else {
            this.$alert.success('Thêm học sinh thành công !')
            this.$refs.clear.clearSelected()
            this.cancel()
          }
          this.$loading.active = false
        } catch (error) {
          this.$alert.error(error)
          this.$loading.active = false
        }
      } else {
        this.$alert.error('Vui lòng chọn một học sinh!')
        this.$loading.active = false
      }
    },
    onExcelImport() {
      this.isExcelImport = true
    }
  }
}
</script>
